import axios from "axios";
import ApiConstants from "../Utils/ApiConstant";
import { OtpVerificationType } from "../Utils/Enums";
import SessionManager from "../Utils/Session";

const AuthService = {
  login: async (email, password) => {
    try {
      const response = await axios.post(ApiConstants.login, {
        email: email.trim(),
        password: password.trim(),
      });

      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },

  verifyOTP: async (email, otp, type) => {
    try {
      const response = await axios.post(ApiConstants.verifyOtp, { email: email.trim(), otp: otp.trim(), type: type.trim() });

      if (response.status === 200) {
        const token = response.data.token;
        type == OtpVerificationType.forgotPassword ?
          SessionManager.shared.setForgotPasswordToken(token) :
          SessionManager.shared.setSessionToken(token);
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },

  forgotPassword: async (email) => {
    try {
      const response = await axios.post(ApiConstants.forgotPassword, {
        email: email.trim(),
      });

      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },

  resetPassword: async (newPassword) => {
    try {
      const response = await axios.post(
        ApiConstants.resetPassword,
        { newPassword: newPassword.trim() },
        {
          headers: {
            Authorization: `Bearer ${SessionManager.shared.getForgotPasswordToken()}`,
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },

  getDetails: async () => {
    try {
      const response = await axios.get(ApiConstants.getAdminDetails, {
        headers: {
          Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
        },
      });
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error
    }
  },

  changePassword: async (currentPassword, newPassword) => {
    try {
      const response = await axios.put(ApiConstants.changePassword, { currentPassword: currentPassword.trim(), newPassword: newPassword.trim() }, {
        headers: {
          Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
        },
      });
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },

  updateProfileDetails: async (name, email, mobileNumber) => {
    try {
      const response = await axios.put(ApiConstants.updateProfileDetails, { name: name.trim(), email: email.trim(), mobileNumber: mobileNumber.trim() }, {
        headers: {
          Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
        },
      });
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },

  updateProfilePic: async (file) => {
    const formData = new FormData();
    formData.append("profile_pic", file)
    try {
      const response = await axios.put(ApiConstants.updateProfileDetails, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
        },
      });
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },

  registerUser: async (
    userId,
    firstname,
    middlename,
    lastname,
    gender,
    schoolname,
    dateOfBirth,
    medium,
    class_id,
    email,
    mobilenumber,
    address,
    state,
    district,
    taluka,
    pincode,
    applicablepackages
  ) => {
    try {
      const response = await axios.post(ApiConstants.registerUser, {
        user_id: userId || "",
        firstName: firstname || "",
        middleName: middlename || "",
        lastName: lastname || "",
        gender: gender || "",
        schoolName: schoolname || "",
        dateOfBirth: dateOfBirth || "",
        medium: medium || "",
        classId: class_id || "",
        email: email || "",
        mobile: mobilenumber || "",
        address: address || "",
        state: state || "",
        district: district || "",
        taluka: taluka || "",
        pinCode: pincode || "",
        packages: applicablepackages || "",
      }, {
        headers: {
          Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
        },
      });
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(response.error);
    }
  } catch(error) {
    throw error;
  }
},


  getAllUsers: async (offset, limit, searchQuery) => {
    try {
      const response = await axios.get(ApiConstants.getAllUsers + `?offset=${offset}&limit=${limit}&searchQuery=${searchQuery.trim()}`, {
        headers: {
          Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
        },
      });
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },

  getBulkUploadUsersHistory: async (offset, limit, searchQuery) => {
    try {
      const response = await axios.get(ApiConstants.getBulkUploadUsersHistory + `?offset=${offset}&limit=${limit}&searchQuery=${searchQuery.trim()}`, {
        headers: {
          Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
        },
      });
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },

  bulkUploadUsers: async (file) => {
    const formData = new FormData();
    formData.append("file", file)
    try {
      const response = await axios.post(ApiConstants.bulkUploadUsers, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
        },
      });
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },

  resetPassword: async (id) => {
    try {
      const response = await axios.post(ApiConstants.resetPassword, {
        user_id: id
      },
        {
          headers: {
            Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
          },
        });
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },
resendCredentials: async (id) => {
    try {
      const response = await axios.post(ApiConstants.resendCredentials, {
        user_id: id
      },
        {
          headers: {
            Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
          },
        });
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },
  updateUserStatus: async (id, status) => {
    try {
      const response = await axios.put(ApiConstants.updateUserStatus, {
        id: id,
        is_active: status
      }, {
        headers: {
          Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
        },
      });
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },
};

export default AuthService;
